import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { URLS } from "utils/constants";
import {
  IconLayoutDashboardFilled,
  IconSettings,
  IconSettings2,
  IconReport,
} from "@tabler/icons-react";
import "./HRNavigationMenu.css";

const HRNavigationMenu = () => {
  const location = useLocation();

  const menuItems = [
    {
      name: "Home",
      href: URLS.v1.HR_HOME,
      icon: IconLayoutDashboardFilled,
    },
    {
      name: "Manage",
      href: URLS.v1.HR_MANAGE,
      icon: IconSettings,
    },
    {
      name: "Master",
      href: URLS.v1.HR_MASTER,
      icon: IconSettings2,
    },
    {
      name: "Setting",
      href: URLS.v1.HR_SETTING,
      icon: IconSettings,
    },
    {
      name: "Report",
      href: URLS.v1.HR_REPORT,
      icon: IconReport,
    },
  ];

  // Check if current path is under HR section
  const isHRPath = location.pathname.startsWith("/v1/hr");

  if (!isHRPath) return null;

  return (
    <div className="hr-navigation-wrapper">
      <div className="hr-navigation-container">
        <div className="hr-navigation-tabs">
          {menuItems.map((item, index) => {
            const IconComponent = item.icon;
            const isActive = location.pathname === item.href;
            
            return (
              <NavLink
                key={index}
                to={item.href}
                className={`hr-nav-tab ${isActive ? "active" : ""}`}
              >
                <IconComponent size={18} />
                <span>{item.name}</span>
              </NavLink>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HRNavigationMenu;